export default "__VITE_ASSET__qOUyc7JB__"